module.exports = __webpack_public_path__ + "static/media/va.1e90de32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/va.png
// module id = 2014
// module chunks = 0